import { Subtitle, Title1 } from "@bounce/design-system"
import { DEFAULT_LANGUAGE, Trans, useLocale, useTranslation } from "@bounce/i18n"
import { Button } from "@bounce/web-components"

import { config } from "../../../../../config/config"
import { useUrl } from "../../../../../libs/router"
import { HeroContainer } from "@/components/Generic/HeroContainer/HeroContainer"

import background from "./assets/joshuas-shop.png"

type Props = {
  className?: string
}

export const Hero = ({ className }: Props) => {
  const [t] = useTranslation("marketing-partner")
  const { locale } = useLocale()
  const { getUrl } = useUrl()

  return (
    <HeroContainer image={background} hideImageOnMobile={false} className={className}>
      <Title1 className="mb-3 mt-1 break-words md:mb-3.5 lg:mb-5">
        <Trans i18nKey="page.partner.titleP3">
          More customers,
          <br />
          More money
        </Trans>
      </Title1>
      <Subtitle>
        {t("page.partner.subHeader", "Start a new revenue stream by becoming a Bounce Partner today.")}
      </Subtitle>
      <div className="mt-4 flex flex-col flex-wrap md:mt-8 md:w-auto md:max-w-[512px] md:flex-row md:gap-x-6">
        <Button
          {
            // In Japan, we're linking an Intercom workflow with an enquiry form.
            ...(locale !== "ja-JP" && { href: `${config.apps.partner}/signup/store` })
          }
          rel="noindex nofollow"
          className="mt-4 w-full max-w-full md:mt-3.5 md:w-fit xl:mt-4"
          textClassName="line-clamp-1">
          {t("page.partner.becomeAPartner", "Become a Partner")}
        </Button>
        <Button
          href={getUrl({ path: "/ls/affiliates", language: DEFAULT_LANGUAGE })}
          rel="noindex nofollow"
          variant="ghost"
          className="mt-4 w-full max-w-full md:mt-3.5 md:w-fit md:p-0 xl:mt-4"
          textClassName="line-clamp-1">
          {t("page.partner.joinAffiliateProgram", "Join affiliate program")}
        </Button>
      </div>
    </HeroContainer>
  )
}
